import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { LocalKeys } from '~/app/lib/local-keys'
import { createModalStore } from '../global'
import { Workspace } from './workspace.type'

export const useCreateWorkspaceModal = createModalStore()

interface DefaultWorkspaceState {
  defaultWorkspace: Workspace | null
  setDefaultWorkspace: (wp: Workspace | null) => void
}

interface SelectedWorkspaceState {
  selectedWorkspace: Workspace | null
  setSelectedWorkspace: (wp: Workspace | null) => void
}

export const useDefaultWorkspaceStore = create<DefaultWorkspaceState>()(
  persist(
    (set, get) => ({
      defaultWorkspace: null,
      setDefaultWorkspace: (wp) => {
        if (wp === null && get().defaultWorkspace) {
          console.log('🔄 Clearing default workspace')
        } else if (wp) {
          console.log('✅ Setting default workspace:', wp.name)
        }
        set({ defaultWorkspace: wp })
      },
    }),
    {
      name: LocalKeys.SELECTED_WORKSPACE,
    }
  )
)

export const useSelectedWorkspaceStore = create<SelectedWorkspaceState>()((set) => ({
  selectedWorkspace: null,
  setSelectedWorkspace: (wp) => set({ selectedWorkspace: wp }),
}))
